<template>
    <div class="flex items-center h-full">
        <vs-button @click="editData" type="filled" icon-pack="feather" icon="icon-edit"></vs-button>
    </div>
</template>

<script>
export default {
  name: 'EditActions',
  methods: {
    editData () {
      const client_users_id = this.params.data.basic_details.client_users_id
      this.$router.push(
        {
          name: 'clients-details',
          params: { client_id: client_users_id, editable: true }
        }
      )
    }
  }
}
</script>